import { Flower2, Scissors, Leaf, Dumbbell, Brain, Syringe } from "lucide-react";

export const slugify = (s) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const img = (n) => `/img/${n}.jpg`;

const RAW = [
  {
    slug: "esthetique-et-beaute", name: "Esthétique et beauté", icon: Flower2, cover: "beaute1",
    images: ["beaute1", "beaute2", "beaute3", "beaute4"],
    jobs: ["Esthéticienne", "Technicienne en ongles", "Styliste d'ongles", "Maquilleuse", "Spécialiste en épilation",
      "Technicienne en extensions de cils", "Propriétaire de salon d'esthétique", "Propriétaire de spa"],
  },
  {
    slug: "coiffure-et-image-personnelle", name: "Coiffure et image personnelle", icon: Scissors, cover: "coiffure3",
    images: ["coiffure1", "coiffure2", "coiffure3", "coiffure4"],
    jobs: ["Coiffeur / Coiffeuse", "Barbier / Barbière", "Coloriste", "Styliste capillaire",
      "Technicien en extensions capillaires", "Propriétaire de salon de coiffure", "Propriétaire de barbershop"],
  },
  {
    slug: "bien-etre-et-sante-naturelle", name: "Bien-être et santé naturelle", icon: Leaf, cover: "bienetre3",
    images: ["bienetre1", "bienetre2", "bienetre3", "bienetre4"],
    jobs: ["Massothérapeute", "Kinésithérapeute", "Orthothérapeute", "Naturopathe", "Réflexologue", "Aromathérapeute",
      "Propriétaire de clinique de bien-être"],
  },
  {
    slug: "conditionnement-physique", name: "Conditionnement physique", icon: Dumbbell, cover: "fitness3",
    images: ["fitness1", "fitness2", "fitness3", "fitness4"],
    jobs: ["Entraîneur personnel", "Professeur de yoga", "Professeur de Pilates", "Kinésiologue", "Coach sportif",
      "Instructeur de conditionnement physique", "Propriétaire de gym", "Propriétaire de centre d'entraînement"],
  },
  {
    slug: "sante-mentale-et-developpement-personnel", name: "Santé mentale et développement personnel", icon: Brain, cover: "mental1",
    images: ["mental1", "mental2", "mental3", "mental4"],
    jobs: ["Psychologue", "Psychothérapeute", "Travailleur social", "Coach de vie", "Conseiller en développement personnel",
      "Propriétaire de clinique"],
  },
  {
    slug: "medecine-esthetique", name: "Médecine esthétique", icon: Syringe, cover: "medecine1",
    images: ["medecine1", "medecine2", "medecine3", "beaute3"],
    jobs: ["Médecin esthétique", "Infirmier / Infirmière en injection", "Professionnel en soins médico-esthétiques",
      "Propriétaire de clinique médico-esthétique"],
  },
];

export const SECTORS = RAW.map((s) => ({
  ...s,
  cover: img(s.cover),
  summary: s.jobs.slice(0, 3).join(", ") + ", etc.",
  jobs: [...s.jobs, "Autre métier"].map((name, i) => ({
    name: name === "Autre métier" ? `Autre métier — ${s.name.toLowerCase()}` : name,
    slug: name === "Autre métier" ? "autre-metier" : slugify(name),
    image: img(s.images[i % s.images.length]),
  })),
}));

export const findSector = (slug) => SECTORS.find((s) => s.slug === slug);
export const findJob = (sector, slug) => sector?.jobs.find((j) => j.slug === slug);
